// src/utils/jwt.ts

import { createRemoteJWKSet, jwtVerify, type JWTPayload } from "jose";

/**
 * Builds a URL for fetching the JWKS based on the VITE_JWKS_URI environment variable.
 */
const jwtJsonWebKeySetUriString: string = import.meta.env.VITE_JWKS_URI;
const jwtJsonWebKeySetUri = new URL(jwtJsonWebKeySetUriString);

/**
 * Remote JWK Set for verifying JWT signatures.
 */
export const remoteJwkSet = createRemoteJWKSet(jwtJsonWebKeySetUri);

/**
 * Verifies a JWT's signature and claims (issuer, audience, expiration) against the JWKS.
 * Reads the expected issuer from VITE_JWT_ISSUER.
 */
export async function verifyToken(tokenString: string): Promise<JWTPayload> {
  const { payload } = await jwtVerify(tokenString, remoteJwkSet, {
    issuer: import.meta.env.VITE_JWT_ISSUER,
    // audience: "your-client-id",
  });
  return payload;
}
